import React from 'react'
import { useState, useEffect } from "react"
import axios from "axios"
import { motion, AnimatePresence } from "framer-motion"
import { Plus, Edit, Trash2, Save, X, Building2, ImageIcon, Eye, EyeOff, UserCheck } from "lucide-react"

function HrApplications() {
    const [investors, setInvestors] = useState([])
      const [showForm, setShowForm] = useState(false)
      const [formData, setFormData] = useState({})
      const [editingId, setEditingId] = useState(null)
      const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
      const [deleteId, setDeleteId] = useState(null)
      const [toggle, setToggle] = useState(false)
      const [loading, setLoading] = useState(false)
    
      // NEW: track which investor is being processed for active toggle
      const [processingId, setProcessingId] = useState(null)
    
      
      const fetchApplications = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/hrapplication`)
          setInvestors(res.data.applications)
          console.log(res)
        } catch (error) {
          console.error("Error fetching investors:", error)
        }
      }
    
      // Fetch toggle state
      const fetchToggleState = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/investortoggle`)
          setToggle(res.data.enabled)
        } catch (error) {
          console.error("Error fetching toggle state:", error)
        }
      }
    
  
    
      useEffect(() => {
        fetchApplications()
        fetchToggleState()
      }, [])
    
      
    
      
    
      const handleEdit = (investor) => {
        setFormData(investor)
        setEditingId(investor._id)
        setShowForm(true)
      }
    
      const handleDeleteConfirm = (id) => {
        setShowDeleteConfirm(true)
        setDeleteId(id)
      }
    
      const handleDelete = async (id) => {
        console.log(deleteId)
        try {
          await axios.delete(`${process.env.REACT_APP_API_URL}/api/hrapplication/${deleteId}`)
          setShowDeleteConfirm(false)
          setDeleteId(null)
          fetchApplications()
        } catch (error) {
          console.error("Error deleting Application:", error)
        }
      }
    
      const getTypeColor = (type) => {
        switch (type) {
          case "Our Key Partner":
            return "bg-purple-100 text-purple-800 border-purple-200"
          case "Our Partner":
            return "bg-blue-100 text-blue-800 border-blue-200"
          case "Our Investor":
            return "bg-green-100 text-green-800 border-green-200"
          default:
            return "bg-gray-100 text-gray-800 border-gray-200"
        }
      }
    
      const openNewForm = () => {
        setFormData({ type: "", name: "", image: "" })
        setEditingId(null)
        setShowForm(true)
      }

        const handleFormSubmit = async (e) => {
          e.preventDefault()
          setLoading(true)
          try {
           
            setFormData({ type: "", name: "", image: "" })
            setShowForm(false)
            setEditingId(null)
            fetchApplications()
          } catch (error) {
            console.error("Error submitting form:", error)
          } finally {
            setLoading(false)
          }
        }
      
    
      // UPDATED: toggle active/inactive for a given investor
    
  return (
     <div className="min-h-screen bg-gray-50">
      <div className="w-full mx-auto p-6">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div>
               <h1 className="text-3xl font-bold text-gray-900">HR Applications</h1>
<p className="text-gray-500">
  Manage and review job postings, company details, and recruitment requests
</p>

              </div>
            </div>

           
          </div>
        </div>

        {/* Status Banner */}
        

        {/* Investors Grid */}
      
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <AnimatePresence>
              {investors.length === 0 ? (
                <div className="col-span-full flex flex-col items-center justify-center py-16">
                  <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                    <Building2 className="w-12 h-12 text-gray-400" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">0 application Found</h3>
                  
                  {/* <button
                    onClick={openNewForm}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    Add First Investor
                  </button> */}
                </div>
              ) : (
                investors.map((investor, index) => (
                  <motion.div
                    key={investor._id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ delay: index * 0.1 }}
                    className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all duration-300"
                  >
                    <div className="flex items-start gap-4 mb-4">
                      <div className="w-16 h-16 rounded-xl overflow-hidden border-2 border-gray-200 flex-shrink-0">
                        {investor.image ? (
                          <img
                            src={investor.image || "/placeholder.svg"}
                            alt={investor.name}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.style.display = "none"
                              e.target.nextSibling.style.display = "flex"
                            }}
                          />
                        ) : null}
                        <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                          <ImageIcon className="w-6 h-6 text-gray-400" />
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-semibold text-gray-900 truncate">{investor.jobTitle}</h3>
                        <div className="flex items-center gap-3 mt-1">
                        <div className="flex items-center gap-3 mt-1">
  <p className="text-sm font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-md shadow-sm">
    {investor.companyName}
  </p>
</div>
                          {/* Active / Inactive status badge */}
                         
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-2">
                      <button
                        onClick={() => handleEdit(investor)}
                        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                      >
                        <Eye className="w-3 h-3" />
                        View
                      </button>
                      <button
                        onClick={() => handleDeleteConfirm(investor._id)}
                        className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-3 h-3" />
                        Delete
                      </button>
                    </div>
                  </motion.div>
                ))
              )}
            </AnimatePresence>
          </div>
        
        
      </div>

      {/* Form Modal */}
      <AnimatePresence>
        {showForm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto "
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <h2 className="text-xl font-semibold text-gray-900">
                   View Application
                  </h2>
                  <button
                    onClick={() => setShowForm(false)}
                    className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors"
                  >
                    <X className="w-4 h-4 text-gray-600" />
                  </button>
                </div>
              </div>

                <form onSubmit={handleFormSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-3">
                     <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Company Name *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,companyName:e.target.value})}
      value={formData.companyName}
      type="text"
      name="companyName"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter company name"
      required
    />
  </div>

  {/* 02. GST Identification Number */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      GST Identification Number *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,GSTno:e.target.value})}
      value={formData.GSTno}
      type="text"
      name="gstNumber"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter GST number"
      required
    />
  </div>

  {/* 03. Email ID */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Email ID *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,email:e.target.value})}
      value={formData.email}
      type="email"
      name="email"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter official email ID"
      required
    />
  </div>

  {/* 04. Phone Number */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Phone Number *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,phone:e.target.value})}
      value={formData.phone}
      type="tel"
      name="phone"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter phone number"
      required
    />
  </div>

  {/* 05. Contact Person */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Contact Person
    </label>
    <input
      onChange={(e)=>setFormData({...formData,contactperson:e.target.value})}
      value={formData.contactperson}
      type="text"
      name="contactPerson"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter contact person name"
    />
  </div>

  {/* 06. Company Address */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Company Address
    </label>
    <input
      onChange={(e)=>setFormData({...formData,companyAddress:e.target.value})}
      value={formData.companyAddress}
      type="text"
      name="companyAddress"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter full address"
    />
  </div>

  {/* 07. Website */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Website
    </label>
    <input
      onChange={(e)=>setFormData({...formData,website:e.target.value})}
      value={formData.website}
      type="url"
      name="website"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="https://example.com"
    />
  </div>

  {/* 08. Job Title / Designation */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Job Title / Designation *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,jobTitle:e.target.value})}
      value={formData.jobTitle}
      type="text"
      name="jobTitle"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter job title"
      required
    />
  </div>

  {/* 09. Department / Domain */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Department / Domain *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,department:e.target.value})}
      value={formData.department}
      type="text"
      name="department"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. Development, HR, Marketing"
      required
    />
  </div>

  {/* 10. Number of Positions */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Number of Positions *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,postions:e.target.value})}
      value={formData.postions}
      type="number"
      name="positions"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter number of openings"
      required
    />
  </div>

  {/* 11. Job Type */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Job Type *
    </label>
    <select
      onChange={(e)=>setFormData({...formData,jobType:e.target.value})}
      value={formData.jobType}
      defaultValue={''}
      name="jobType"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      required
    >
      <option value="">Select job type</option>
      <option value="Full-time">Full-time</option>
      <option value="Part-time">Part-time</option>
      <option value="Internship">Internship</option>
      <option value="Contract-based">Contract-based</option>
    </select>
  </div>

  {/* 12. Job Location */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Job Location *
    </label>
    <input
      onChange={(e)=>setFormData({...formData,jobLocation:e.target.value})}
      value={formData.jobLocation}
      type="text"
      name="jobLocation"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="On-site / Remote / Hybrid"
      required
    />
  </div>

  {/* 13. Working Days */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Working Days
    </label>
    <input
      onChange={(e)=>setFormData({...formData,workingDays:e.target.value})}
      value={formData.workingDays}
      type="text"
      name="workingDays"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="5 or 6 days per week"
    />
  </div>

  {/* 14. Working Hours */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Working Hours / Shift Timings
    </label>
    <input
      onChange={(e)=>setFormData({...formData,workingHours:e.target.value})}
      value={formData.workingHours}
      type="text"
      name="workingHours"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. 9 AM - 6 PM"
    />
  </div>

  {/* 15. Salary Offered */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Salary Offered (CTC / Stipend)
    </label>
    <input
      onChange={(e)=>setFormData({...formData,salary:e.target.value})}
      value={formData.salary}
      type="text"
      name="salary"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. ₹5 LPA or ₹15,000/month"
    />
  </div>

  {/* 16. Incentives / Bonuses */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Performance Incentives / Bonuses
    </label>
    <input
      onChange={(e)=>setFormData({...formData,incentives:e.target.value})}
      value={formData.incentives}
      type="text"
      name="incentives"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. Annual bonus, performance rewards"
    />
  </div>

  {/* 17. Benefits */}
  <div className="md:col-span-2">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Benefits (selectable options)
    </label>
    <div className="flex flex-wrap gap-4">
      {['Accommodation', 'Travel / Bus facility', 'Food', 'Insurance'].map((benefit) => (
        <label key={benefit} className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="benefits"
            value={benefit}
            checked={formData.benefits.includes(benefit)}
            onChange={(e) => {
              const isChecked = e.target.checked;
              setFormData((prev) => {
                let updatedBenefits = [...prev.benefits];
                if (isChecked && !updatedBenefits.includes(benefit)) updatedBenefits.push(benefit);
                else if (!isChecked) updatedBenefits = updatedBenefits.filter((b) => b !== benefit);
                return { ...prev, benefits: updatedBenefits };
              });
            }}
          />
          <span>{benefit}</span>
        </label>
      ))}
    </div>
  </div>

  {/* 18. Preferred Qualification */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Preferred Qualification
    </label>
    <input
      onChange={(e)=>setFormData({...formData,qualification:e.target.value})}
      value={formData.qualification}
      type="text"
      name="qualification"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. BCA, MCA, B.Tech, etc."
    />
  </div>

  {/* 19. Required Skills */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Required Skills
    </label>
    <input
      onChange={(e)=>setFormData({...formData,skills:e.target.value})}
      value={formData.skills}
      type="text"
      name="skills"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. React, Node.js, MongoDB"
    />
  </div>

  {/* 20. Work Experience */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Work Experience (Min - Max in years)
    </label>
    <input
      onChange={(e)=>setFormData({...formData,experience:e.target.value})}
      value={formData.experience}
      type="text"
      name="experience"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. 0 - 2 years"
    />
  </div>

  {/* 21. Languages */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Languages Known
    </label>
    <input
      onChange={(e)=>setFormData({...formData,languages:e.target.value})}
      value={formData.languages}
      type="text"
      name="languages"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. English, Hindi, Tamil"
    />
  </div>

  {/* 22. Gender Preference */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Gender Preference (if any)
    </label>
    <input
      onChange={(e)=>setFormData({...formData,gender:e.target.value})}
      value={formData.gender}
      type="text"
      name="gender"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. Male / Female / Any"
    />
  </div>

  {/* 23. Age Limit */}
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Age Limit
    </label>
    <input
      onChange={(e)=>setFormData({...formData,age:e.target.value})}
      value={formData.age}
      type="text"
      name="ageLimit"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="E.g. 18 - 35 years"
    />
  </div>

  {/* 25. Additional Notes */}
  <div className="md:col-span-2">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Additional Notes or Expectations
    </label>
    <textarea
      onChange={(e)=>setFormData({...formData,additionalNote:e.target.value})}
      value={formData.additionalNote}
      name="notes"
      rows="4"
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      readOnly
      placeholder="Enter any additional details or expectations..."
    ></textarea>
  </div>

  {/* Action Buttons */}
  <div className="md:col-span-2 flex gap-3 pt-4">
    <button
      type="button"
      onClick={() => setShowForm(false)}
      className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors"
    >
      Close
    </button>
   
  </div>

                   
                </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Delete Confirmation Modal */}
      <AnimatePresence>
        {showDeleteConfirm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-xl shadow-xl max-w-md w-full p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                  <Trash2 className="w-6 h-6 text-red-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Confirm Delete</h3>
                  <p className="text-sm text-gray-500">This action cannot be undone</p>
                </div>
              </div>

              <p className="text-gray-700 mb-6">
                Are you sure you want to delete this Application? This will permanently remove them from the system.
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={()=>handleDelete(formData._id)}
                  className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                >
                  Delete
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default HrApplications
